import React from "react";
import { FaCheck } from "react-icons/fa";
import mobile_push_icon_selected_white from "assets/notificationicons/mobile-push-icon-selected-white.png";
import mobile_push_icon_deselected_white from "assets/notificationicons/mobile-push-icon-deselected-white.png";
import email_icon_selected_white from "assets/notificationicons/email-icon-selected-white.png";
import email_icon_deselected_white from "assets/notificationicons/email-icon-deselected-white.png";

export default function GroupSubscriptionControls({
  group,
  selectedDevices = [],
  toggleDevice,
  handleSave,
  saveSuccess,
  auth,
  setLoginPopupOpen,
  triggerLoginOpen,
}) {
  // Check if all devices in group are subscribed to email/push
  const allDevicesEmailEnabled = group.devices.every((device) => {
    const selected = selectedDevices.find((d) => d.id === device.id);
    return selected && selected.emailEnabled === 1;
  });

  const allDevicesPushEnabled = group.devices.every((device) => {
    const selected = selectedDevices.find((d) => d.id === device.id);
    return selected && selected.pushEnabled === 1;
  });

  const handleGroupToggle = (type) => {
    // Determine if all devices are currently enabled for this type
    const allEnabled = group.devices.every((device) => {
      const selected = selectedDevices.find((d) => d.id === device.id);
      return selected && selected[`${type}Enabled`] === 1;
    });

    // If all are enabled, turn all off; otherwise, turn all on
    group.devices.forEach((device) => {
      const selected = selectedDevices.find((d) => d.id === device.id);
      // Only toggle if not already in desired state
      if (allEnabled) {
        // Turn off
        if (selected && selected[`${type}Enabled`] === 1) {
          toggleDevice(device, type);
        }
      } else {
        // Turn on
        if (!selected || selected[`${type}Enabled`] === 0) {
          toggleDevice(device, type);
        }
      }
    });
  };

  const handleSaveClick = async () => {
    // Show login popup if not authenticated
    if (!auth?.auth?.email) {
      setLoginPopupOpen?.(true);
      triggerLoginOpen?.();
      return;
    }

    // Otherwise save normally
    await handleSave?.();
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "10px 20px",
        backgroundColor: "#0d2235",
        marginTop: 5,
        marginBottom: 10,
        borderRadius: 5,
      }}
    >
      {/* Subscription Controls */}
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: 20,
          alignItems: "center",
        }}
      >
        {/* Email Toggle */}
        <div
          onClick={() => handleGroupToggle("email")}
          style={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: 8,
          }}
        >
          <img
            src={
              allDevicesEmailEnabled
                ? email_icon_selected_white
                : email_icon_deselected_white
            }
            style={{
              width: 30,
              height: 22,
            }}
            alt={`Email notifications ${
              allDevicesEmailEnabled ? "enabled" : "disabled"
            }`}
          />
          <span style={{ color: "white", fontSize: 14 }}>
            Email {allDevicesEmailEnabled ? "On" : "Off"}
          </span>
        </div>

        {/* Push Toggle */}
        <div
          onClick={() => handleGroupToggle("push")}
          style={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: 8,
          }}
        >
          <img
            src={
              allDevicesPushEnabled
                ? mobile_push_icon_selected_white
                : mobile_push_icon_deselected_white
            }
            style={{
              width: 22,
              height: 26,
            }}
            alt={`Push notifications ${
              allDevicesPushEnabled ? "enabled" : "disabled"
            }`}
          />
          <span style={{ color: "white", fontSize: 14 }}>
            Push {allDevicesPushEnabled ? "On" : "Off"}
          </span>
        </div>
      </div>

      {/* Save Button */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 10,
        }}
      >
        {saveSuccess && (
          <span style={{ color: "#4CAF50", fontSize: 14 }}>Saved!</span>
        )}
        <button
          style={{
            background: "#436c9a",
            borderRadius: 5,
            padding: "8px 16px",
            color: "white",
            border: "none",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: 8,
            fontSize: 14,
          }}
          onClick={handleSaveClick}
        >
          <FaCheck size={14} />
          {!auth?.auth?.email ? "Login to Save" : "Save"}
        </button>
      </div>
    </div>
  );
}
